<template>
  <div class="main-page">
    <i class="iconfont iconLogo_zhankai"></i>
    <div class="register-page">
        <div class="back" @click="back">< BACK</div>
        <div class="title title-first">{{ $t('vip账号注册') }}</div>
        <div class="title title-two">{{ $t('If you have any question, please call 15885') }}</div>
        <div class="form-box">
          <el-form class="input-box" ref="registerForm" :model="formData" :rules="rules" label-width="300px" label-suffix=":" :inline="true" label-position="top">
            <el-form-item :label="$t('推荐人')" prop="recommendedBy">
              <el-input :placeholder="$lang('请输入')" v-model="formData.recommendedBy" maxlength="100" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('推荐人联系方式')" prop="recommendedByContact">
              <el-input :placeholder="$lang('请输入')" v-model="formData.recommendedByContact" maxlength="100" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Tax card name/NID name')" prop="name">
              <el-input :placeholder="$lang('请输入')" v-model="formData.name" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('客户简称')" prop="abbreviation">
              <el-input :placeholder="$lang('请输入')" v-model="formData.abbreviation" maxlength="50" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('客户类型')" prop="customerType">
              <el-input :placeholder="$lang('请输入')" v-model="customerType" disabled type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('税务登记号')" prop="taxRegistrationCode">
              <el-input :placeholder="$lang('请输入')" v-model="formData.taxRegistrationCode" type="text"></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$t('证件号码')" prop="idCardNumber">
              <el-input :placeholder="$lang('请输入')" v-model="formData.idCardNumber" type="text"></el-input>
            </el-form-item> -->
            <el-form-item :label="$t('注册地址')" prop="taxpayerRegistrationAddress">
              <el-input :placeholder="$lang('请输入')" v-model="formData.taxpayerRegistrationAddress" maxlength="200" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('联系人姓名')" prop="contactName">
              <el-input :placeholder="$lang('请输入')" v-model="formData.contactName" maxlength="50" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('联系人手机')" prop="contactMobile">
              <el-input :placeholder="$lang('请输入')" v-model="formData.contactMobile" maxlength="11" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('省')" prop="provinceId">
              <el-select v-model="formData.provinceId" filterable @change="dataProvinceChange($event)">
                <el-option
                  v-for="item in provinceArray"
                  :key="item.id"
                  :label="(item.nativeName +'（'+ item.enName + '）')"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('城市')" prop="cityId">
              <el-select v-model="formData.cityId" filterable @change="dataCityChange($event)">
                <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="(item.nativeName +'（'+ item.enName + '）')"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('地区')" prop="areaId">
              <el-select v-model="formData.areaId">
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="(item.nativeName +'（'+ item.enName + '）')"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('街道地址')" prop="address">
              <el-input :placeholder="$lang('请输入')" v-model="formData.address" maxlength="200" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('楼号')" prop="buildingNo">
              <el-input :placeholder="$lang('请输入')" v-model="formData.buildingNo" maxlength="100" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('返款周期')" prop="rebatePeriodId">
              <el-select v-model="formData.rebatePeriodId">
                <el-option
                  v-for="(item, index) in rebatePeriodList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('代收结算账户开户行')" prop="collectionSettlementBankName">
              <el-input :placeholder="$lang('请输入')" v-model="formData.collectionSettlementBankName" maxlength="50" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('代收结算账户')" prop="collectionSettlementBankAccountName">
              <el-input :placeholder="$lang('请输入')" v-model="formData.collectionSettlementBankAccountName" maxlength="50" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('代收结算帐号')" prop="collectionSettlementBankAccount">
              <el-input :placeholder="$lang('请输入')" v-model="formData.collectionSettlementBankAccount" maxlength="20" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('账单发送电子邮箱')" prop="financialEmail">
              <el-input :placeholder="$lang('请输入')" v-model="formData.financialEmail" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('IBAN')" prop="iban">
              <el-input :placeholder="$lang('请输入')" v-model="formData.iban" type="text"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="btn">
          <el-button type="primary" :loading="loading" @click="submit">{{ $t('注册') }}</el-button>
        </div>
    </div>
  </div>
</template>

<script>
import bg2 from '@/assets/images/bg/bg2.jpg'
import { RESPONSE_SUCCESS } from '@constants'
import { RULES } from '@utils/rules'
import * as Api from '@api/base/public'
export default {
  name: 'Register',
  data() {
    return {
      bg2,
      loading: false,
      customerTypeOptions: [],
      customerType: this.$t('企业'),
      rebatePeriodList: [
        {
          label: 'Once a week',
          value: 1101
        },
        {
          label: 'Twice a week',
          value: 1100
        },
        {
          label: 'Three times a week',
          value: 1108
        }
      ],
      formData: {
        recommendedBy: '', // 推荐人
        recommendedByContact: '', // 推荐人电话
        name: '', // Tax card name/NID name
        abbreviation: '', // 客户简称
        taxRegistrationCode: '', // 税务登记号
        // idCardNumber: '', // 证件号码
        taxpayerRegistrationAddress: '', // 注册地址
        contactName: '', // 联系人姓名
        contactMobile: '', // 联系人手机
        provinceId: '', // 省
        cityId: '', // 市
        areaId: '', // 区
        address: '', // 街道地址
        buildingNo: '', // 楼号
        rebatePeriodId: '', // 返款周期
        collectionSettlementBankName: '', // 代收结算账户开户行
        collectionSettlementBankAccountName: '', // 代收结算账户
        collectionSettlementBankAccount: '', // 代收结算帐号
        financialEmail: '', // 账单发送电子邮箱
        iban: '', // IBAN
        countryId: '1',
      },
      rules: {
        name: [RULES.required],
        abbreviation: [RULES.required],
        taxRegistrationCode: [RULES.required],
        // idCardNumber: [RULES.required],
        taxpayerRegistrationAddress: [RULES.required],
        contactName: [RULES.required],
        contactMobile: [RULES.required, RULES.checkMobile],
        provinceId: [RULES.requiredSelect],
        cityId: [RULES.requiredSelect],
        areaId: [RULES.requiredSelect],
        address: [RULES.required],
        buildingNo: [RULES.required],
        collectionSettlementBankName: [RULES.required],
        collectionSettlementBankAccountName: [RULES.required],
        collectionSettlementBankAccount: [RULES.required],
        financialEmail: [RULES.required, RULES.checkEmail],
        iban: [RULES.required],
      },
      provinceArray: [],
      cityList: [],
      areaList: [],
    }
  },
  watch: {
    'formData.taxRegistrationCode'(val) {
      this.formData.taxRegistrationCode = val.replace(/[^0-9]/ig, '')
    },
    'formData.contactMobile'(val) {
      this.formData.contactMobile = val.replace(/[^0-9]/ig, '')
    },
    'formData.collectionSettlementBankAccount'(val) {
      this.formData.collectionSettlementBankAccount = val.replace(/[^0-9]/ig, '')
    }
  },
  created() {
    this.getProList()
  },
  methods: {
    // 获取省数据
    async getProList() {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 2 })
      if (code === RESPONSE_SUCCESS) {
        this.provinceArray = data
        this.cityList = []
        this.areaList = []
        console.log(this.provinceArray)
      } else {
        this.$message.error(msg)
      }
    },
    dataProvinceChange(value) {
      this.getCityList(value)
    },
    // 获取城市数据
    async getCityList(parentId) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        this.cityList = data
        this.areaList = []
        this.formData.cityId = ''
        this.formData.areaId = ''
      } else {
        this.$message.error(msg)
      }
    },
    dataCityChange(value) {
      this.getAreaList(value)
    },
    // 获取区域数据
    async getAreaList(parentId) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 4, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        this.areaList = data
        this.formData.areaId = ''
      } else {
        this.$message.error(msg)
      }
    },
    // 提交
    submit() {
      this.$refs['registerForm'].validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            const { code, msg } = await Api.register(this.formData)
            this.loading = false
            if (code === RESPONSE_SUCCESS) {
              this.$message.success(this.$t('注册成功'))
              this.$refs['registerForm'].resetFields()
            } else {
              this.$message.error(msg)
            }
          } catch (err) {
            this.loading = false
          }
        }
      })
    },
    back() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.main-page {
  background-image: url('~@/assets/images/bg/bg2.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
  padding: 138px 0 60px 0;
  box-sizing: border-box;
  position: relative;
  .iconLogo_zhankai {
    font-size: 60px;
    position: absolute;
    z-index: 2;
    top: 5%;
    left: 4.16667%;
    color: $--color-primary;
    // font-size: 28px !important;
  }
}

.register-page {
  width: 1300px;
  height: 100%;
  overflow: auto;
  background-color: rgb(10, 0, 17, .6);
  border-radius: 4px;
  margin: 0 auto;
  padding-bottom: 30px;
  position: relative;

  &::-webkit-scrollbar {
    width: 5px;
 }

  &::-webkit-scrollbar-track {
    background-color: black;
  }

  &::-webkit-scrollbar-thumb {
    background: #4e4e4e;
    border-radius: 5px;
  }

  .title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 30px;
    text-align: center;
    color: #ffffff;
    font-size: 20px;
  }

  .title-first {
    margin-top: 64px;
    font-size: 36px;
    background-image:-webkit-linear-gradient(bottom, #2A2E40, #EEEEEE);
    -webkit-background-clip: text;
    -webkit-text-fill-color:transparent;
  }
  .title-two {
    color: #ffffff;
    opacity: .6;
  }
  .form-box {
    display: flex;
    justify-content: space-between;
    padding: 0 310px;
  }
  .input-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .back {
    position: absolute;
    left: 40px;
    top: 25px;
    font-size: 20px;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    cursor: pointer;
  }

  ::v-deep {
    .el-input {
      width: 300px !important;
    }
    .el-input__inner {
      width: 300px;
      background: #ffffff;
    }
    .el-form-item__label {
      color: #ffffff;
    }
  }
}

.btn {
  text-align: center;
}
</style>
